import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { z } from "zod";
import { Form } from "@/components/ui/form";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { Input } from "@/components/ui/input";
import Layout2 from "@/components/Layout/Layout2";
import LeftBar2 from "@/components/Layout/LeftBar2";
import { backofficeLinks } from "@/components/lib/SidebarLinks";
import { FaUserCheck, FaUserXmark } from "react-icons/fa6";
import Paginat from "@/components/lib/paginat";
import FormInputField from "@/components/lib/from-input-field";
import StaffReportTable from "@/components/backoffice/all-staff/staff-report/staff-report-table";
import { Search, Clock8, ClockAlert, User2 } from "lucide-react";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { fetchAttendanceReport } from "@/redux/slice/staff-management/staff-attendance";
import useAuth from "@/hooks/useAuth";
import TableSkeleton from "@/components/skeleton/table-skeletion";
import moment from "moment";
import { useSearch } from "@/hooks/useSearch";
import OnlyTableSekeleton from "@/components/skeleton/only-table-skeleton";
import { toast } from "react-hot-toast";

const schema = z.object({
  date: z.string().optional(),
});

function StaffReports() {
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const { user } = useAuth();
  const [firstLoading, setFirstLoading] = useState(true);
  const [tableLoading, setTableLoading] = useState(false);

  const [searchText, setSearchText] = useState("");

  const form = useForm({
    resolver: zodResolver(schema),
    defaultValues: {
      date: "",
    },
  });
  const selectedDate = form.watch("date");

  const { attendanceLoading, attendanceReport } = useSelector(
    (state) => state.staffManage.attendance
  );
  useEffect(() => {
    if (user?.restaurant_id) {
      const monthYear = moment(selectedDate).format("YYYY-MM-DD");
      const fetchData = async () => {
        if (firstLoading) {
          setFirstLoading(true);
        } else {
          setTableLoading(true);
        }
        const res = await dispatch(
          fetchAttendanceReport({
            restaurant_id: user.restaurant_id,
            date: monthYear,
            page: page,
            limit: perPage,
          })
        );
        if (fetchAttendanceReport.fulfilled.match(res)) {
          setFirstLoading(false);
          setTableLoading(false);
        } else if (fetchAttendanceReport.rejected.match(res)) {
          setFirstLoading(false);
          setTableLoading(false);
          toast.error(res.payload);
        }
      };
      fetchData();
    }
  }, [selectedDate, user?.restaurant_id, page, perPage]);
  const searchData = useSearch(
    attendanceReport?.staff_attendance || [],
    searchText,
    ["staff_id", "name", "designation"],
    300
  );

  if (firstLoading) return <TableSkeleton links={backofficeLinks} />;

  return (
    <Layout2
      LeftBar={<LeftBar2 sidebarLinks={backofficeLinks} />}
      pageName={{ title: "Staff Report" }}
      paths={[
        { name: "Back Office", path: "/backoffice/overview" },
        {
          name: "Staff Management",
          path: "/backoffice/staff-management/staff/all",
        },
        {
          name: "Staff Report",
          path: "/backoffice/staff-management/staff-reports",
        },
      ]}
    >
      <div className="container flex flex-col gap-4 mt-5">
        <div className="flex justify-between items-start md:items-center md:flex-row flex-col gap-5  w-full">
          <div className="flex gap-5 text-white">
            {/* <Select className="">
              <SelectTrigger className="w-[110px] border-gray-600">
                <SelectValue placeholder="Business" />
              </SelectTrigger>
              <SelectContent>
                <SelectGroup>
                  <SelectLabel>Name</SelectLabel>
                  <SelectItem value="apple">XYZ</SelectItem>
                  <SelectItem value="banana">ABS</SelectItem>
                </SelectGroup>
              </SelectContent>
            </Select>
            <Select>
              <SelectTrigger className="w-[110px]">
                <SelectValue placeholder="Location" />
              </SelectTrigger>
              <SelectContent>
                <SelectGroup>
                  <SelectLabel>Name</SelectLabel>
                  <SelectItem value="apple">Khulna</SelectItem>
                  <SelectItem value="banana">Dhaka</SelectItem>
                </SelectGroup>
              </SelectContent>
            </Select>
            <Select>
              <SelectTrigger className="w-[110px]">
                <SelectValue placeholder="Outlet" />
              </SelectTrigger>
              <SelectContent>
                <SelectGroup>
                  <SelectLabel>Name</SelectLabel>
                  <SelectItem value="apple">Bonoul</SelectItem>
                  <SelectItem value="banana">Tunig star</SelectItem>
                </SelectGroup>
              </SelectContent>
            </Select> */}
          </div>
          <div className="w-[260px]"></div>
        </div>

        <div className=" w-full grid grid-cols-2 gap-5 md:grid-cols-4 mb-5">
          <div className="bg-cblack3 py-4 px-8 flex gap-5 rounded-md border border-gray-700">
            <div className="p-2 px-3 bg-cblack7 flex justify-center items-center rounded text-cyellow">
              < User2 size={30} />
            </div>
            <div className="space-y-1 text-white">
              <h2 className="text-lg">Total Staff</h2>
              <h2 className="text-lg font-bold text-cyellow">
                {attendanceReport?.summary?.total || 0}
              </h2>
            </div>
          </div>
          <div className="bg-cblack3 py-4 px-8 flex gap-5 rounded-md border border-gray-700">
            <div className="p-2 px-3 bg-cblack7 flex justify-center items-center rounded text-color7">
              <FaUserCheck size={30} />
            </div>
            <div className="space-y-1 text-white">
              <h2 className="text-lg">Present</h2>
              <h2 className="text-lg font-bold text-color7">
                {" "}
                {attendanceReport?.summary?.present || 0}
              </h2>
            </div>
          </div>
          <div className="bg-cblack3 py-4 px-8 flex gap-5 rounded-md border border-gray-700">
            <div className="p-2 px-3 bg-cblack7 flex justify-center items-center rounded text-cred">
              <FaUserXmark size={30} />
            </div>
            <div className="space-y-1 text-white">
              <h2 className="text-lg">Absent</h2>
              <h2 className="text-lg font-bold text-cred">
                {" "}
                {attendanceReport?.summary?.absent || 0}
              </h2>
            </div>
          </div>
          <div className="bg-cblack3 py-4 px-8 flex gap-5 rounded-md border border-gray-700">
            <div className="p-2 px-3 bg-cblack7 flex justify-center items-center rounded text-cred">
              <ClockAlert size={30} />
            </div>
            <div className="space-y-1 text-white">
              <h2 className="text-lg">Late</h2>
              <h2 className="text-lg font-bold text-cred">
                {" "}
                {attendanceReport?.summary?.late || 0}
              </h2>
            </div>
          </div>
        </div>
        <div>
          <div className="w-full flex justify-between lg:flex-row flex-col gap-5 items-start lg:items-center">
            <div className="md:w-1/2 w-full">
              <Form {...form}>
                <form className="w-64">
                  <FormInputField
                    name="date"
                    placeholder={"dd/mm/yy"}
                    form={form}
                    type="date"
                    style="bg-cblack3 text-cwhite2"
                    label={"Search By Date"}
                  />
                </form>
              </Form>
            </div>
            <div>{/* <h2 className="text-cyellow">Total Staff: 50</h2> */}</div>
            <div className="md:w-1/2 w-full flex flex-col  gap-1.5 justify-end items-end">
              <div className="flex gap-3 justify-center items-center">
                <div className="relative">
                  <Search
                    size={18}
                    className="text-cwhite3 absolute top-2 left-2"
                  />
                  <Input
                    onChange={(e) => setSearchText(e.target.value)}
                    placeholder="Search by Name or ID"
                    className="bg-cblack3 pl-8"
                  />
                </div>
                <div className="flex gap-1 justify-center items-center">
                  <h3 className="text-white">Show</h3>
                  <Select
                    onValueChange={(value) => setPerPage(Number(value))}
                    value={perPage.toString()}
                  >
                    <SelectTrigger className="w-[60px]">
                      <SelectValue placeholder="10" />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectGroup>
                        <SelectItem value="10">10</SelectItem>
                        <SelectItem value="20">20</SelectItem>
                        <SelectItem value="40">40</SelectItem>
                      </SelectGroup>
                    </SelectContent>
                  </Select>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-5">
            {tableLoading ? (
              <OnlyTableSekeleton header={false} />
            ) : (
              <StaffReportTable data={searchData} />
            )}
          </div>
          <div>
            <Paginat
              pagination={attendanceReport?.pagination}
              onPageChange={(page) => setPage(page)}
              className="mt-4"
            />
          </div>
        </div>
      </div>
    </Layout2>
  );
}

export default StaffReports;

const dateSchema = z.object({
  date: z.string().min(1, "Date is required"),
});
